import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { unsetCard } from './actions';
import { selectCard } from './selectors';
import CardFace from './CardFace';
import { Modal, modalName, modalTimeout } from './styled';

/** A card shown full screen, to read it. Tapping anywhere or pressing Escape closes it. */
const Card = () => {
  const dispatch = useDispatch();
  const card = useSelector(selectCard);
  const [opened, open] = useState(false);
  const modal = useRef(null);

  useEffect(() => {
    if (!card) {
      return undefined;
    }

    open(true);
    const closeOnEscape = ({ key }) => key === 'Escape' && open(false);
    document.addEventListener('keyup', closeOnEscape);

    return () => document.removeEventListener('keyup', closeOnEscape);
  }, [card]);

  return (
    <CSSTransition
      in={opened}
      timeout={modalTimeout}
      classNames={modalName}
      nodeRef={modal}
      onExited={() => dispatch(unsetCard())}
    >
      <Modal ref={modal} onClick={() => open(false)} aria-hidden={!opened}>
        {card && <CardFace card={card} />}
      </Modal>
    </CSSTransition>
  );
};

export default Card;
